/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(7016): Could not find a declaration file for module 'loda... Remove this comment to see the full error message
import isEqual from "lodash.isequal";
// @ts-expect-error TS(6133): 'useRef' is declared but its value is never read.
import { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { cn } from "tailwind-variants";
import ArtworkAlert from "./ArtworkAlert.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import ArtworkShippingProgress from "./ArtworkShippingProgress.vue";
import StepNumber from "./common/StepNumber.vue";
import { useDtfStore } from "./store";
import "./ArtworkQuantity.scss";

export default function ArtworkQuantity({
  index = 0,
  artwork = null,
  disabled = false,
  showFreeShipping = false,
  isMultiUpload = false,
  ...restProps
}) {
  const intl = useIntl();
  const store = useDtfStore();
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [previousData, setPreviousData] = useState({ quantity: null });

  // @ts-expect-error TS(6133): 'modalArtworks' is declared but its value is never... Remove this comment to see the full error message
  function modalArtworks() {
    // @ts-expect-error TS(4111): Property 'modalArtworks' comes from an index signa... Remove this comment to see the full error message
    return store.modalArtworks;
  }

  function outOfStock() {
    // @ts-expect-error TS(4111): Property 'outOfStock' comes from an index signatur... Remove this comment to see the full error message
    return store.outOfStock;
  }

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs;
  }

  function simulation() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    return store.simulation;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return store.sticker;
  }

  function isPuff() {
    // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
    return store.isPuff;
  }

  function variantId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return store.variantId;
  }

  function minStickerQuantity() {
    // @ts-expect-error TS(4111): Property 'minStickerQuantity' comes from an index ... Remove this comment to see the full error message
    return store.minStickerQuantity;
  }

  // @ts-expect-error TS(6133): 'isV15' is declared but its value is never read.
  function isV15() {
    // @ts-expect-error TS(4111): Property 'isV15' comes from an index signature, so... Remove this comment to see the full error message
    return store.isV15;
  }

  function isMobile() {
    // @ts-expect-error TS(4111): Property 'isMobile' comes from an index signature,... Remove this comment to see the full error message
    return store.isMobile;
  }

  function isJerseyNumbers() {
    // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
    return store.isJerseyNumbers;
  }

  function isLetters() {
    // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
    return store.isLetters;
  }

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  // @ts-expect-error TS(6133): 'summary' is declared but its value is never read.
  function summary() {
    // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
    return store.summary;
  }

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return store.showStepsUI;
  }

  function quantity() {
    if (isMobile()) {
      // @ts-expect-error TS(2339): Property 'quantity' does not exist on type 'never'... Remove this comment to see the full error message
      return artwork?.quantity || 0;
    }
    // @ts-expect-error TS(2339): Property 'quantity' does not exist on type 'never'... Remove this comment to see the full error message
    return artwork?.quantity;
  }

  function pricing() {
    if (isJerseyNumbers() || isLetters()) {
      return letterNumberArtwork();
    }
    // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
    if (artwork?.isFile) {
      return simulation();
    }
    // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
    return artwork?.pricing || simulation();
  }

  function percentage() {
    if (pricing()?.percentage) {
      return Number(pricing()?.percentage).toFixed(0);
    }
    return null;
  }

  function retailPrice() {
    if (pricing()?.retailPrice) {
      return Number(pricing().retailPrice).toFixed(2);
    }
    return null;
  }

  function unitPrice() {
    if (pricing()?.unitPrice) {
      return Number(pricing().unitPrice).toFixed(2);
    }
    return null;
  }

  function id() {
    return `artwork[${index}][variants][${variantId()}][quantity]`;
  }

  function retailTotal() {
    // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
    return (retailPrice() * quantity()).toFixed(2);
  }

  function total() {
    // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
    const value = unitPrice() * quantity();
    if (value > 0) {
      return value.toFixed(2);
    }
    return null;
  }

  function showRetailPrice() {
    return retailTotal() !== total();
  }

  function isMinQuantityInvalid() {
    if (sticker() || isPuff()) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return quantity() && quantity() < minStickerQuantity();
    }
    return false;
  }

  function showShippingProgress() {
    if ((isJerseyNumbers() || isLetters()) && quantity() && showFreeShipping) {
      return true;
    }
    return (
      !printAsIs() &&
      quantity() &&
      showFreeShipping &&
      artwork &&
      // @ts-expect-error TS(2339): Property 'isSimulated' does not exist on type 'nev... Remove this comment to see the full error message
      !artwork.isSimulated &&
      // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message
      !artwork.isLoading
    );
  }

  function showBorderUI() {
    return showStepsUI() && !isMultiUpload;
  }

  useEffect(() => {
    updatePdpDates();
  }, [showShippingProgress()]);

  useEffect(
    () => () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    },
    []
  );

  function updateArtworkValues(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updateArtworkValues(...args);
  }

  function getArtworksPricing(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.getArtworksPricing(...args);
  }

  function submitForm(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.submitForm(...args);
  }

  function updatePdpDates(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updatePdpDates(...args);
  }

  function allowNumbersOnly(e: any) {
    const { value } = e.target;
    const quantityValue = value.replace(/[^0-9]/g, "").replace(/^0/, "");
    e.target.value = quantityValue;
    updateArtworkValues({
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      index: artwork.originalIndex,
      quantity: quantityValue
    });
  }

  function handleInput(e: any) {
    allowNumbersOnly(e);
    debouncedHandleInputBlur();
  }

  function debouncedHandleInputBlur() {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(debounceTimeout);
    setDebounceTimeout(
      // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      setTimeout(() => {
        handleInputBlur();
      }, 1000)
    );
  }

  function handleInputBlur() {
    const currentData = {
      quantity: quantity()
    };
    if (isEqual(currentData, previousData)) {
      return;
    }
    setPreviousData(currentData);
    getArtworksPricing();
    updatePdpDates();
  }

  function formatCurrency(value: any) {
    if (value === null) return null;
    return intl.formatNumber(parseFloat(value), {
      style: "currency",
      currency: "USD"
    });
  }

  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("artwork-quantity scope-45146366", restProps?.className, {
        "artwork-quantity--with-border": showBorderUI(),
        "artwork-quantity--with-border--invalid": showBorderUI() && isMinQuantityInvalid()
      })}
    >
      {!printAsIs() && !isJerseyNumbers() && !isLetters() && !showBorderUI() ? (
        <div className="artwork-quantity__title scope-45146366"> Quantity </div>
      ) : null}
      {showBorderUI() ? (
        <StepNumber
          className="scope-45146366"
          stepNumber={isPuff() ? 4 : 3}
          content="Add Quantity"
          data-testid="step-number"
        />
      ) : null}
      <div
        className={cn("artwork-quantity__row scope-45146366", {
          "artwork-quantity__row--gang": printAsIs(),
          "artwork-quantity__row--error": isMinQuantityInvalid()
        })}
      >
        {(isJerseyNumbers() || isLetters()) && quantity() ? (
          <div className="artwork-quantity__value scope-45146366">
            <div className="artwork-quantity__label scope-45146366">Quantity</div>
            <div className="artwork-quantity__jersey-numbers-total scope-45146366">
              {quantity()}
            </div>
          </div>
        ) : null}
        <div
          className={cn("artwork-quantity__prices scope-45146366", {
            hidden: printAsIs() || isJerseyNumbers() || isLetters()
          })}
        >
          {isJerseyNumbers() || isLetters() ? (
            <div className="artwork-quantity__label scope-45146366"> Unit Price </div>
          ) : null}
          <div className="artwork-quantity__retail-price scope-45146366">
            {formatCurrency(retailPrice())}
          </div>
          <div className="artwork-quantity__actual-price scope-45146366">
            {formatCurrency(unitPrice())}
          </div>
        </div>
        {!isJerseyNumbers() && !isLetters() ? (
          <div className="artwork-quantity__input-wrapper scope-45146366">
            {printAsIs() ? (
              <div className="artwork-quantity__title-wrapper scope-45146366">
                <label
                  className="artwork-quantity__title scope-45146366"
                  htmlFor={id()}
                  data-testid="artwork-quantity-title"
                >
                  Quantity
                </label>
              </div>
            ) : null}
            <input
              className={cn("scope-45146366", {
                "artwork-quantity__input js-quantity-form-input": true,
                "artwork-quantity__input--invalid": isMinQuantityInvalid()
              })}
              id={id()}
              // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
              maxLength="4"
              type="tel"
              name={id()}
              autoComplete="off"
              data-hj-allow={true}
              data-variant-id={variantId()}
              value={quantity()}
              disabled={disabled}
              onInput={handleInput}
              onBlur={handleInputBlur}
              onKeyDown={e => {
                if (e.key !== "Enter") return;
                e.preventDefault();
                submitForm(e);
              }}
              data-testid="artwork-quantity-input"
            />
            {outOfStock() ? (
              <UseSvg
                className="artwork-quantity__icon-cross scope-45146366"
                icon="cross"
                width="12"
                height="12"
                data-testid="artwork-quantity-icon-cross"
              />
            ) : null}
          </div>
        ) : null}
        {outOfStock() ? (
          <span className="artwork-quantity__out-of-stock-notice scope-45146366">Out of stock</span>
        ) : null}
        {printAsIs() ? (
          <div className="artwork-quantity__total-section scope-45146366">
            {quantity() > 0 && total() ? (
              <div className="artwork-quantity__total scope-45146366">
                <div className="artwork-quantity__total-wrapper scope-45146366">
                  {showRetailPrice() ? (
                    <div className="artwork-quantity__total-old scope-45146366">
                      {formatCurrency(retailTotal())}
                    </div>
                  ) : null}
                  <div className="artwork-quantity__total-price scope-45146366">
                    <span className="artwork-quantity__total-inline-title scope-45146366">
                      Total:
                    </span>{" "}
                    {formatCurrency(total())}
                  </div>
                </div>
              </div>
            ) : null}
            {/* @ts-expect-error TS(2531): Object is possibly 'null'. */}
            {quantity() > 0 && percentage() > 0 ? (
              <div className="artwork-quantity__off scope-45146366">{percentage()}% off </div>
            ) : null}
          </div>
        ) : null}
        {!printAsIs() && quantity() > 0 && total() ? (
          <div
            className={cn("scope-45146366", {
              "artwork-quantity__total": true,
              "artwork-quantity__total--mobile": isMobile()
            })}
          >
            <div
              className={cn("scope-45146366", {
                "artwork-quantity__total-title": !isJerseyNumbers() && !isLetters(),
                "artwork-quantity__label": isJerseyNumbers() || isLetters()
              })}
            >
              {" "}
              Total{" "}
            </div>
            <div className="artwork-quantity__total-wrapper scope-45146366">
              {showRetailPrice() ? (
                <div className="artwork-quantity__total-old scope-45146366">
                  {formatCurrency(retailTotal())}
                </div>
              ) : null}
              <div className="artwork-quantity__total-price scope-45146366">
                {formatCurrency(total())}
              </div>
            </div>
          </div>
        ) : null}
        {/* @ts-expect-error TS(2531): Object is possibly 'null'. */}
        {!printAsIs() && quantity() > 0 && percentage() > 0 ? (
          <div className="artwork-quantity__off scope-45146366">{percentage()}% off </div>
        ) : null}
        {isMinQuantityInvalid() ? (
          <ArtworkAlert
            className="artwork-quantity__error scope-45146366"
            data-testid="artwork-quantity-error"
          >
            {"Minimum quantity of "}
            {minStickerQuantity()}
            {" per design"}
          </ArtworkAlert>
        ) : null}
        {showShippingProgress() ? (
          <ArtworkShippingProgress
            className="scope-45146366"
            data-testid="artwork-shipping-progress"
          />
        ) : null}
      </div>
    </div>
  );
}
